import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next'
import styles from "../../../AccountingPage.module.scss";
import {
    PatchEmployeeData,
    getAllowanceCategories,
    getDeductionTypes,
    getEmployeeHistoryPayData,
} from "service/AccountingService";

const EmployeeDetailForms = ({
    activeForm,
    setActiveForm,
    setNotify,
    setRender,
    id,
    data,
    foun_id,
    departments,
    positions,
    setPositions,
    departmentID,
    positionID,
    setPositionID,
    setDepartmentID,
    setDepartments,
    branchID,
    branches,
    handleSelectBranch,
    order,
    setOrder,
    stavka,
    setStavka,
    editDateFrom,
    setEditDateFrom,
    editDateTo,
    setEditDateTo,
    
}) => {
  const { t } = useTranslation('common')


    const [salary, setSalary] = useState("");
    const [salaryDateFrom, setSalaryDateFrom] = useState("");
    const [salaryDateTo, setSalaryDateTo] = useState("");

    const [allowanceCategories, setAllowanceCategories] = useState([]);
    const [allowanceCategoryId, setAllowanceCategoryId] = useState("");
    const [allowancePercent, setAllowancePercent] = useState("");
    const [allowanceDateFrom, setAllowanceDateFrom] = useState("");
    const [allowanceDateTo, setAllowanceDateTo] = useState("");

    const [deductionTypes, setDeductionTypes] = useState([]);
    const [deductionTypeId, setDeductionTypeId] = useState("");
    const [deductionPercent, setDeductionPercent] = useState("");
    const [deductionDateFrom, setDeductionDateFrom] = useState("");
    const [deductionDateTo, setDeductionDateTo] = useState("");

    const [order_fire, setOrderFire] = useState("");
    const [order_restore, setOrderRestore] = useState("");
    const [order_leave, setOrderLeave] = useState("");
    const [order_backleave, setOrderBackLeave] = useState("");
    const [order_trip, setOrderTrip] = useState("");
    const [order_backtrip, setOrderBackTrip] = useState("");
    const [order_sick, setOrderSick] = useState("");
    const [order_backsick, setOrderBackSick] = useState("");
    const [order_unpaidleave, setOrderUnpaidLeave] = useState("");
    const [order_backunpaidleave, setOrderBackUnpaidLeave] = useState("");
    const [order_maternity, setOrderMaternity] = useState("");
    const [order_backmaternity, setOrderBackMaternity] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    const MONTHS = [
        "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
        "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ];
    const currentMonthIndex = new Date().getMonth();
    const [selectedMonth, setSelectedMonth] = useState(MONTHS[currentMonthIndex]);
    const currentYear = new Date().getFullYear();
    const YEARS = [];
    for (let y = currentYear - 5; y <= currentYear + 1; y++) YEARS.push(y);
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const [salary_amount, setSalaryAmount] = useState("");
    const [deduction_amount, setDeductionAmount] = useState("");
    const [allowance_amount, setAllowanceAmount] = useState("");
    const [paymentType, setPaymentType] = useState("");
    const [contractAmount, setContractAmount] = useState("");
    const [hourlyRate, setHourlyRate] = useState("");
    const [hoursCount, setHoursCount] = useState("");
    const [hourlyTotal, setHourlyTotal] = useState("");
    const [totalSalary, setTotalSalary] = useState("");

    useEffect(() => {
        if (foun_id) {
            getAllowanceCategories(foun_id).then(res => setAllowanceCategories(res.data));
            getDeductionTypes(foun_id).then(res => setDeductionTypes(res.data));
        }
    }, [foun_id]);

    useEffect(() => {
        if (activeForm === "salarypay" && data?.id) {
            setSalaryAmount("");
            setDeductionAmount("");
            setAllowanceAmount("");
            getEmployeeHistoryPayData(data.id).then(res => {
                const history = res.data || [];
                const salary = history
                    .filter(item => item.change_type === "salary" && item.status === "Действует")
                    .reduce((sum, item) => sum + (parseFloat(item.new_value) || 0), 0);
                const deduction = history
                    .filter(item => item.change_type === "deduction" && item.status === "Действует")
                    .reduce((sum, item) => sum + (parseFloat(item.new_value) || 0), 0);
                const allowance = history
                    .filter(item => item.change_type === "allowance" && item.status === "Действует")
                    .reduce((sum, item) => sum + (parseFloat(item.new_value) || 0), 0);
                setSalaryAmount(salary ? salary.toString() : "");
                setDeductionAmount(deduction ? deduction.toString() : "");
                setAllowanceAmount(allowance ? allowance.toString() : "");
            });
        } else {
            setSalaryAmount("");
            setDeductionAmount("");
            setAllowanceAmount("");
        }
    }, [activeForm, data?.id]);

    useEffect(() => {
        const hTotal = (parseFloat(hourlyRate) || 0) * (parseFloat(hoursCount) || 0);
        setHourlyTotal(hTotal ? hTotal.toString() : "");
        const sAmount = parseFloat(salary_amount) || 0;
        const cAmount = parseFloat(contractAmount) || 0;
        const baseAmount = sAmount + cAmount + hTotal;
        const dPercent = parseFloat(deduction_amount) || 0;
        const aPercent = parseFloat(allowance_amount) || 0;
        const dAmount = baseAmount * dPercent / 100;
        const aAmount = baseAmount * aPercent / 100;
        const tSalary = baseAmount - dAmount + aAmount;
        setTotalSalary(tSalary ? tSalary.toString() : "");
    }, [salary_amount, deduction_amount, allowance_amount, contractAmount, hourlyRate, hoursCount]);

    const handleSubmitEdit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append("status", "edit");
        formData.append("order", order);
        formData.append("department", departmentID);
        formData.append("position", positionID);
        formData.append("stavka", stavka);
        formData.append("date_from", editDateFrom);
        formData.append("date_to", editDateTo);
        await PatchEmployeeData(id, formData);

        setNotify({
            isOpen: true,
            message: "Данные успешно изменены!",
            type: "success",
            sound: "success",
        });
        setActiveForm("");
        setRender(true);
    };
    const handleSubmitSalary = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("status", "pay");
        formData.append("salary", salary);
        formData.append("date_from", salaryDateFrom);
        formData.append("date_to", salaryDateTo);
        await PatchEmployeeData(id, formData);
        setNotify({ isOpen: true, message: "Оклад обновлён!", type: "success", sound: "success" });
        setActiveForm("");
        setRender(true);
    };

    const handleSubmitAllowance = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("status", "allowance");
        formData.append("allowance_category_id", allowanceCategoryId);
        formData.append("percent", allowancePercent);
        formData.append("date_from", allowanceDateFrom);
        formData.append("date_to", allowanceDateTo);
        await PatchEmployeeData(id, formData);
        setNotify({ isOpen: true, message: "Надбавка добавлена/обновлена!", type: "success", sound: "success" });
        setActiveForm("");
        setRender(true);
    };

    const handleSubmitDeduction = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("status", "deduction");
        formData.append("deduction_type_id", deductionTypeId);
        formData.append("percent", deductionPercent);
        formData.append("date_from", deductionDateFrom);
        formData.append("date_to", deductionDateTo);
        await PatchEmployeeData(id, formData);
        setNotify({ isOpen: true, message: "Удержание добавлено/обновлено!", type: "success", sound: "success" });
        setActiveForm("");
        setRender(true);
    };

    const handleSubmitSalaryPay = async (e) => {
        e.preventDefault();
        if (!paymentType) {
            setNotify({
                isOpen: true,
                message: "Пожалуйста, выберите тип выплаты!",
                type: "error",
            });
            return;
        }
        const formData = new FormData();
        formData.append("status", "salarypay");
        formData.append("payment_type", paymentType);
        formData.append("salary_amount", salary_amount || "");
        formData.append("deduction_amount", deduction_amount || "");
        formData.append("allowance_amount", allowance_amount || "");
        formData.append("contract_amount", contractAmount || "");
        formData.append("hourly_rate", hourlyRate || "");
        formData.append("hours_count", hoursCount || "");
        formData.append("hourly_total", hourlyTotal || "");
        formData.append("total_salary", totalSalary || "");
        formData.append("month", selectedMonth);
        formData.append("year", selectedYear);
        await PatchEmployeeData(id, formData);
        setNotify({ isOpen: true, message: "Выплата добавлена!", type: "success", sound: "success" });
        setActiveForm("");
        setRender(true);
    };

    const handleStatusChange = async (statusKey, orderValue, notifyMsg, dateFromValue, dateToValue) => {
        if (!orderValue) {
            setNotify({
                isOpen: true,
                message: "Введите приказ!",
                type: "error",
            });
            return;
        }
        if (!dateFromValue) {
            setNotify({
                isOpen: true,
                message: "Введите дату с!",
                type: "error",
            });
            return;
        }
        const formData = new FormData();
        formData.append("status", statusKey);
        formData.append("order", orderValue);
        formData.append("date_from", dateFromValue);
        formData.append("date_to", dateToValue);
        await PatchEmployeeData(id, formData);
        setNotify({
            isOpen: true,
            message: notifyMsg,
            type: "success",
            sound: "success",
        });
        setActiveForm("");
        setRender(true);
        setDateFrom("");
        setDateTo("");
    };

    if (!activeForm) return null;

    return (
        <div className={styles.content_header_two_stud}>
            <h2 className={styles.project__h}>{t('auto.component_employeedetailforms.k1')}</h2>
            {activeForm === "edit" && (
                <form onSubmit={handleSubmitEdit} style={{ width: "100%" }}>
                    <div className={styles.form_input}>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                            <label>{t('auto.components_contractamountcontent.k5')}</label>
                            <select
                                value={branchID}
                                onChange={(e) => handleSelectBranch(e.target.value)}
                            >
                                <option value="">{t('auto.components_contractamountcontent.k6')}</option>
                                {Array.isArray(branches) && branches.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                            <label>{t('auto.components_contractamountcontent.k7')}</label>
                            <select
                                value={departmentID}
                                onChange={(e) => setDepartmentID(e.target.value)}
                            >
                                <option value="">{t('auto.components_contractamountcontent.k8')}</option>
                                {Array.isArray(departments) && departments.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                            <label>{t('pages.employeeWizard.position_lbl')}</label>
                            <select
                                value={positionID}
                                onChange={(e) => setPositionID(e.target.value)}
                            >
                                <option value="">{t('auto.component_employeedetailforms.k2')}</option>
                                {Array.isArray(positions) && positions.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>{t('auto.emppositionform_addempposition.k2')}</label>
                            <input
                                type="number"
                                placeholder={t('auto.component_employeedetailforms.k33')}
                                value={stavka}
                                onChange={(e) => setStavka(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k3')}</label>
                            <input
                                type="text"
                                placeholder={t('auto.component_employeedetailforms.k34')}
                                value={order}
                                onChange={(e) => setOrder(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k4')}</label>
                            <input
                                type="date"
                                value={editDateFrom}
                                onChange={e => setEditDateFrom(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k5')}</label>
                            <input
                                type="date"
                                value={editDateTo}
                                onChange={e => setEditDateTo(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={styles.create_footer} style={{ justifyContent: "start" }}>
                        <button
                            type="submit"
                            className={styles.open_btn_sub}
                            style={{
                                background: "#5c5cff", 
                                color: "white"
                            }}
                        >
                            {t('common.save')}
                        </button>
                    </div>
                </form>
            )}

            {["fire", "restore", "cancelfire", "leave", "backleave", "trip", "backtrip", "sick", "backsick", "maternity", "backmaternity", "unpaidleave", "backunpaidleave"].map((formKey) => (
                activeForm === formKey && (
                    <form
                        key={formKey}
                        onSubmit={(e) => {
                            e.preventDefault();
                            let orderVal, notifyMsg;
                            switch (formKey) {
                                case "fire": orderVal = order_fire; notifyMsg = "Сотрудник уволен!"; setOrderFire(""); break;
                                case "restore": orderVal = order_restore; notifyMsg = "Сотрудник восстановлен!"; setOrderRestore(""); break;
                                case "cancelfire": orderVal = order_restore; notifyMsg = "Увольнение отменено!"; setOrderRestore(""); break;
                                case "leave": orderVal = order_leave; notifyMsg = "Сотрудник отправлен в отпуск!"; setOrderLeave(""); break;
                                case "backleave": orderVal = order_backleave; notifyMsg = "Сотрудник возвращён с отпуска!"; setOrderBackLeave(""); break;
                                case "trip": orderVal = order_trip; notifyMsg = "Сотрудник отправлен в командировку!"; setOrderTrip(""); break;
                                case "backtrip": orderVal = order_backtrip; notifyMsg = "Сотрудник возвращён с командировки!"; setOrderBackTrip(""); break;
                                case "sick": orderVal = order_sick; notifyMsg = "Сотрудник отправлен на больничный!"; setOrderSick(""); break;
                                case "backsick": orderVal = order_backsick; notifyMsg = "Сотрудник возвращён с больничного!"; setOrderBackSick(""); break;
                                case "maternity": orderVal = order_maternity; notifyMsg = "Сотрудник отправлен в декрет!"; setOrderMaternity(""); break;
                                case "backmaternity": orderVal = order_backmaternity; notifyMsg = "Сотрудник возвращён с декрета!"; setOrderBackMaternity(""); break;
                                case "unpaidleave": orderVal = order_unpaidleave; notifyMsg = "Сотрудник отправлен в отпуск без содержания!"; setOrderUnpaidLeave(""); break;
                                case "backunpaidleave": orderVal = order_backunpaidleave; notifyMsg = "Сотрудник возвращён с отпуска без содержания!"; setOrderBackUnpaidLeave(""); break;
                                default: orderVal = ""; notifyMsg = ""; break;
                            }
                            handleStatusChange(
                                formKey,
                                orderVal,
                                notifyMsg,
                                dateFrom,
                                formKey === "fire" ? null : dateTo
                            );
                        }}
                        style={{ width: "100%" }}
                    >
                        <div className={styles.form_input}>
                            <div>
                                <label>
                                    {formKey === "fire" && "Приказ об увольнении:"}
                                    {formKey === "restore" && "Приказ о восстановлении:"}
                                    {formKey === "cancelfire" && "Приказ об отмене увольнения:"}
                                    {formKey === "leave" && "Приказ об отпуске:"}
                                    {formKey === "backleave" && "Приказ о возвращении с отпуска:"}
                                    {formKey === "trip" && "Приказ о командировке:"}
                                    {formKey === "backtrip" && "Приказ о возвращении с командировки:"}
                                    {formKey === "sick" && "Приказ о больничном:"}
                                    {formKey === "backsick" && "Приказ о возвращении с больничного:"}
                                    {formKey === "maternity" && "Приказ о декретном отпуске:"}
                                    {formKey === "backmaternity" && "Приказ о возвращении с декрета:"}
                                    {formKey === "unpaidleave" && "Приказ об отпуске без содержания:"}
                                    {formKey === "backunpaidleave" && "Приказ о возвращении с отпуска без содержания:"}
                                </label>
                                <input
                                    type="text"
                                    placeholder={t('auto.component_employeedetailforms.k34')}
                                    value={
                                        formKey === "fire" ? order_fire :
                                            formKey === "restore" ? order_restore :
                                                formKey === "cancelfire" ? order_restore :
                                                    formKey === "leave" ? order_leave :
                                                        formKey === "backleave" ? order_backleave :
                                                            formKey === "trip" ? order_trip :
                                                                formKey === "backtrip" ? order_backtrip :
                                                                    formKey === "sick" ? order_sick :
                                                                        formKey === "backsick" ? order_backsick :
                                                                            formKey === "maternity" ? order_maternity :
                                                                                formKey === "backmaternity" ? order_backmaternity :
                                                                                    formKey === "unpaidleave" ? order_unpaidleave :
                                                                                        formKey === "backunpaidleave" ? order_backunpaidleave : ""
                                    }
                                    onChange={e => {
                                        switch (formKey) {
                                            case "fire": setOrderFire(e.target.value); break;
                                            case "restore": setOrderRestore(e.target.value); break;
                                            case "cancelfire": setOrderRestore(e.target.value); break;
                                            case "leave": setOrderLeave(e.target.value); break;
                                            case "backleave": setOrderBackLeave(e.target.value); break;
                                            case "trip": setOrderTrip(e.target.value); break;
                                            case "backtrip": setOrderBackTrip(e.target.value); break;
                                            case "sick": setOrderSick(e.target.value); break;
                                            case "backsick": setOrderBackSick(e.target.value); break;
                                            case "maternity": setOrderMaternity(e.target.value); break;
                                            case "backmaternity": setOrderBackMaternity(e.target.value); break;
                                            case "unpaidleave": setOrderUnpaidLeave(e.target.value); break;
                                            case "backunpaidleave": setOrderBackUnpaidLeave(e.target.value); break;
                                            default: break;
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <label>
                                    
                                    {["backleave", "backtrip", "backsick", "backmaternity", "backunpaidleave"].includes(formKey)
                                        ? "Будет работать с:"
                                        : "Дата с:"}
                                </label>
                                <input
                                    type="date"
                                    value={dateFrom}
                                    onChange={e => setDateFrom(e.target.value)}
                                />
                            </div>
                            
                            {formKey !== "fire" && (
                                <div>
                                    <label>
                                        {["backleave", "backtrip", "backsick", "backmaternity", "backunpaidleave"].includes(formKey)
                                            ? "Будет работать по:"
                                            : "Дата по:"}
                                    </label>
                                    <input
                                        type="date"
                                        value={dateTo}
                                        onChange={e => setDateTo(e.target.value)}
                                    />
                                </div>
                            )}
                        </div>
                        <button
                            type="submit"
                            className={styles.open_btn_sub_two}
                            style={{
                                background:
                                    formKey === "fire"
                                        ? "#a00000ff"
                                        : formKey === "restore"
                                            ? "#008000ff"
                                            : formKey === "cancelfire"
                                                ? "#5c5cff"
                                                : formKey === "leave"
                                                    ? "#ec9900ff"
                                                    : formKey === "backleave"
                                                        ? "#5c5cff"
                                                        : formKey === "trip"
                                                            ? "#333333"
                                                            : formKey === "backtrip"
                                                                ? "#5c5cff"
                                                                : formKey === "sick"
                                                                    ? "#0a62a3"
                                                                    : formKey === "backsick"
                                                                        ? "#5c5cff"
                                                                        : formKey === "maternity"
                                                                            ? "#ffb6c1"
                                                                            : formKey === "backmaternity"
                                                                                ? "#5c5cff"
                                                                                : formKey === "unpaidleave"
                                                                                    ? "#20d300"
                                                                                    : formKey === "backunpaidleave"
                                                                                        ? "#5c5cff"
                                                                                        : "#5C5CFF", 
                                color:
                                    [
                                        "fire", "restore", "cancelfire", "leave", "backleave", "trip", "backtrip",
                                        "sick", "backsick", "maternity", "backmaternity", "unpaidleave", "backunpaidleave"
                                    ].includes(formKey)
                                        ? "white"
                                        : "inherit"
                            }}
                        >
                            {
                                formKey === "fire" ? "Уволить" :
                                    formKey === "restore" ? "Восстановить" :
                                        formKey === "cancelfire" ? "Отменить увольнение" :
                                            formKey === "leave" ? "В отпуск" :
                                                formKey === "backleave" ? "Вернуть с отпуска" :
                                                    formKey === "trip" ? "В командировку" :
                                                        formKey === "backtrip" ? "Вернуть с командировки" :
                                                            formKey === "sick" ? "На больничный" :
                                                                formKey === "backsick" ? "Вернуть с больничного" :
                                                                    formKey === "maternity" ? "В декрет" :
                                                                        formKey === "backmaternity" ? "Вернуть с декрета" :
                                                                            formKey === "unpaidleave" ? "В отпуск без содержания" :
                                                                                formKey === "backunpaidleave" ? "Вернуть с отпуска без содержания" : ""
                            }
                        </button>
                    </form>
                )
            ))}

            {activeForm === "salarypay" && (
                <form onSubmit={handleSubmitSalaryPay} style={{ width: "100%" }}>
                    <div className={styles.form_input}>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px", width: "13%" }}>
                            <label>{t('auto.component_employeedetailforms.k6')}</label>
                            <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}>
                                {MONTHS.map((month, idx) => (
                                    <option key={month} value={month}>{month}</option>
                                ))}
                            </select>
                        </div>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px", width: "13%" }}>
                            <label>{t('auto.component_employeedetailforms.k7')}</label>
                            <select value={selectedYear} onChange={e => setSelectedYear(Number(e.target.value))}>
                                {YEARS.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className={styles.form_input}>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px", width: "28%" }}>
                            <label>{t('auto.component_employeedetailforms.k8')}</label>
                            <select value={paymentType} onChange={e => setPaymentType(e.target.value)}>
                                <option value="">{t('auto.component_employeedetailforms.k9')}</option>
                                <option value="Аванс">{t('auto.component_employeedetailforms.k10')}</option>
                                <option value="Отпускные">{t('auto.component_employeedetailforms.k11')}</option>
                                <option value="Командировачные">{t('auto.component_employeedetailforms.k12')}</option>
                                <option value="Больничный">{t('orders.sickleave')}</option>
                                <option value="Декретный">{t('auto.component_employeedetailforms.k13')}</option>
                                <option value="Почасовые">{t('auto.component_employeedetailforms.k14')}</option>
                                <option value="Зарплата">{t('career.salary')}</option>
                            </select>
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k15')}</label>
                            <input type="number" value={contractAmount} onChange={e => setContractAmount(e.target.value)} />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k16')}</label>
                            <input type="number" value={hourlyRate} onChange={e => setHourlyRate(e.target.value)} />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k17')}</label>
                            <input type="number" value={hoursCount} onChange={e => setHoursCount(e.target.value)} />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k18')}</label>
                            <input style={{ background: "#ebebeb" }} type="number" value={hourlyTotal} readOnly />
                        </div>
                    </div>
                    <div className={styles.form_input}>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k19')}</label>
                            <input style={{ background: "#ebebeb" }} type="number" value={salary_amount} readOnly />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k20')}</label>
                            <input style={{ background: "#ebebeb" }} type="number" value={allowance_amount} readOnly />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k21')}</label>
                            <input style={{ background: "#ebebeb" }} type="number" value={deduction_amount} readOnly />
                        </div>


                        <div>
                            <label>{t('auto.component_employeedetailforms.k22')}</label>
                            <input style={{ background: "#ebebeb" }} type="number" value={totalSalary} readOnly />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className={styles.open_btn_sub_two}
                        style={{ background: "#800080", color: "white" }}
                    >
                        {t('auto.component_employeedetailforms.k23')}
                    </button>
                </form>
            )}
            {activeForm === "salary" && (
                <form onSubmit={handleSubmitSalary} style={{ width: "100%" }}>
                    <div className={styles.form_input}>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k24')}</label>
                            <input
                                type="number"
                                placeholder={t('auto.component_employeedetailforms.k35')}
                                value={salary}
                                onChange={(e) => setSalary(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k4')}</label>
                            <input
                                type="date"
                                value={salaryDateFrom}
                                onChange={(e) => setSalaryDateFrom(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k5')}</label>
                            <input
                                type="date"
                                value={salaryDateTo}
                                onChange={(e) => setSalaryDateTo(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className={styles.open_btn_sub_two}
                        style={{
                            background: "#2e8b57", 
                            color: "white"
                        }}
                    >
                        {t('auto.component_employeedetailforms.k25')}
                    </button>
                </form>
            )}
            {activeForm === "allowance" && (
                <form onSubmit={handleSubmitAllowance} style={{ width: "100%" }}>
                    <div className={styles.form_input}>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                            <label>{t('auto.component_employeedetailforms.k26')}</label>
                            <select
                                value={allowanceCategoryId}
                                onChange={(e) => setAllowanceCategoryId(e.target.value)}
                            >
                                <option value="">{t('auto.component_employeedetailforms.k27')}</option>
                                {Array.isArray(allowanceCategories) && allowanceCategories.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k28')}</label>
                            <input
                                type="number"
                                placeholder={t('auto.component_employeedetailforms.k36')}
                                value={allowancePercent}
                                onChange={(e) => setAllowancePercent(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k4')}</label>
                            <input
                                type="date"
                                value={allowanceDateFrom}
                                onChange={(e) => setAllowanceDateFrom(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k5')}</label>
                            <input
                                type="date"
                                value={allowanceDateTo}
                                onChange={(e) => setAllowanceDateTo(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className={styles.open_btn_sub_two}
                        style={{
                            background: "#20b2aa", 
                            color: "white"
                        }}
                    >
                        {t('auto.component_employeedetailforms.k29')}
                    </button>
                </form>
            )}
            {activeForm === "deduction" && (
                <form onSubmit={handleSubmitDeduction} style={{ width: "100%" }}>
                    <div className={styles.form_input}>
                        <div className={styles.div_check} style={{ display: "flex", flexDirection: "column", gap: "0px", margin: "0px" }}>
                            <label>{t('auto.component_employeedetailforms.k30')}</label>
                            <select
                                value={deductionTypeId}
                                onChange={(e) => setDeductionTypeId(e.target.value)}
                            >
                                <option value="">{t('auto.component_employeedetailforms.k31')}</option>
                                {Array.isArray(deductionTypes) && deductionTypes.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k28')}</label>
                            <input
                                type="number"
                                placeholder={t('auto.component_employeedetailforms.k36')}
                                value={deductionPercent}
                                onChange={(e) => setDeductionPercent(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k4')}</label>
                            <input
                                type="date"
                                value={deductionDateFrom}
                                onChange={(e) => setDeductionDateFrom(e.target.value)}
                            />
                        </div>
                        <div>
                            <label>{t('auto.component_employeedetailforms.k5')}</label>
                            <input
                                type="date"
                                value={deductionDateTo}
                                onChange={(e) => setDeductionDateTo(e.target.value)}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className={styles.open_btn_sub_two}
                        style={{
                            background: "#b22222", 
                            color: "white"
                        }}
                    >
                        {t('auto.component_employeedetailforms.k32')}
                    </button>
                </form>
            )}
        </div>
    );
};

export default EmployeeDetailForms;